import { useShallow } from 'zustand/shallow';

import { useDebounce } from '@/shared/hooks';

import { useDagListDashboardStore } from './useDagListDashboardStore';

const SEARCH_DEBOUNCE_MS = 300;

export const useDagListFilterState = () => {
  const {
    filters,
    setSearchQuery,
    setSelectedRunStatus,
    setSelectedFavorite,
    setSelectedMaturity,
    setSelectedTags,
    resetFilters,
  } = useDagListDashboardStore(
    useShallow((state) => ({
      filters: state.filters,
      setSearchQuery: state.setSearchQuery,
      setSelectedRunStatus: state.setSelectedRunStatus,
      setSelectedFavorite: state.setSelectedFavorite,
      setSelectedMaturity: state.setSelectedMaturity,
      setSelectedTags: state.setSelectedTags,
      resetFilters: state.resetFilters,
    }))
  );

  const debouncedSearchQuery = useDebounce(filters.searchQuery, SEARCH_DEBOUNCE_MS);

  return {
    filters,
    debouncedSearchQuery,
    setSearchQuery,
    setSelectedRunStatus,
    setSelectedFavorite,
    setSelectedMaturity,
    setSelectedTags,
    resetFilters,
  };
};
